export default "__VITE_ASSET__e2730cd7__"